import { QUALIFICATION_PAGE_TEXT } from '../../../lang';
import type { OtherTest as ApplicationOtherTestType } from '../../../../Application/graphql';
import { getOptionsLabelClear } from '../../../../Monitor/components';
import { PAGE_TEXT } from '../../../../Application/components/ApplicationForm/lang';
import { otherTestTypeOptions } from '../../../../Application/components';
import { formatDateString } from '../../../../../utils';
import {
  type BlockDataItem,
  BlockDataValueType,
} from '../../../../../components';

const OTHER_TEST_TEXT = PAGE_TEXT.QUALIFICATION.OTHER_TEST;

export const getOtherTestMap = (
  otherTest: ApplicationOtherTestType,
): BlockDataItem[] => {
  const {
    testType,
    testDate,
    result,
    referenceNo,
    supportingDocuments,
    resultAnnouncedIndicator,
  } = otherTest ?? {};

  const {
    totalScore,
    totalPercentile,
    quantitativeScore,
    quantitativePercentile,
    analyticalWritingScore,
    analyticalWritingPercentile,
    verbalScore,
    verbalPercentile,
    integratedReasoningScore,
    integratedReasoningPercentile,
    dataInsightsScore,
    dataInsightsPercentile,
  } = result ?? {};

  const otherTestMap: BlockDataItem[] = [
    {
      label: OTHER_TEST_TEXT.TEST_TYPE,
      value: getOptionsLabelClear(
        otherTestTypeOptions,
        testType,
      ) as BlockDataItem['value'],
    },
    {
      label: OTHER_TEST_TEXT.TEST_DATE,
      value: formatDateString(testDate),
    },
    {
      label: `${OTHER_TEST_TEXT.QUANTITATIVE}/${OTHER_TEST_TEXT.QUANTITATIVE_REASONING} (%)`,
      value: resultAnnouncedIndicator
        ? `${quantitativeScore} (${quantitativePercentile})`
        : undefined,
    },
    {
      label: `${OTHER_TEST_TEXT.ANALYTICAL_WRITING} (%)`,
      value: resultAnnouncedIndicator
        ? `${analyticalWritingScore} (${analyticalWritingPercentile})`
        : undefined,
    },
    {
      label: `${OTHER_TEST_TEXT.VERBAL}/${OTHER_TEST_TEXT.VERBAL_REASONING} (%)`,
      value: resultAnnouncedIndicator
        ? `${verbalScore} (${verbalPercentile})`
        : undefined,
    },
    {
      label: `${OTHER_TEST_TEXT.INTEGRATED_REASONING} (%)`,
      value: resultAnnouncedIndicator
        ? `${integratedReasoningScore} (${integratedReasoningPercentile})`
        : undefined,
    },
    {
      label: `${OTHER_TEST_TEXT.DATA_INSIGHTS} (%)`,
      value: resultAnnouncedIndicator
        ? `${dataInsightsScore} (${dataInsightsPercentile})`
        : undefined,
    },
    {
      label: `${OTHER_TEST_TEXT.TOTAL} (%)`,
      value: resultAnnouncedIndicator
        ? `${totalScore} (${totalPercentile})`
        : undefined,
    },
    {
      label: OTHER_TEST_TEXT.REFERENCE_NO,
      value: referenceNo,
    },
    {
      label: QUALIFICATION_PAGE_TEXT.CERTIFICATE,
      value: supportingDocuments,
      valueType: BlockDataValueType.FILE_ARRAY,
    },
  ];
  return otherTestMap;
};
